<template>
  <div class="col-sm-12 nopads pt-2">
    <Transition name="fade">
        <cable-search
          :user="user"
          @search="fetchCables"
        />
    </Transition>
    <Transition name="fade">
      <div class="col-sm-12">
        <div class="button-container col-sm-12 trip-buttons">
          <button
            class="btn btn-outline-primary form-button"
            :disabled="loading"
            @click="importFromFile"
          >
            {{ $t('common.import_from_file') }}
          </button>
          <button
            v-if="results.length > 0"
            :disabled="results.length < 1"
            class="form-button btn btn-outline-success"
            @click="exportExcel"
          >
            {{ $t('trip.download_excel') }}
          </button>
        </div>
        <cable-list
          v-if="!cable"
          :cables="results"
          @row-clicked="editCable"
        />
      </div>
    </Transition>

    <cable-editor
      v-if="cable != null"
      :cable="cable"
      @close="cable=null"
      @close-and-update="closeAndUpdate"
    />

    <cable-importer
      v-if="showFileImporter"
      @close="showFileImporter = false"
    />

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {downloadHelper} from "../mixins/DownloadMixin";
import CableSearch from "@/components/streetlights/CableSearch";
import CableEditor from "@/components/streetlights/CableEditor";
import CableList from "@/components/streetlights/CableList";
import CableImporter from "@/components/streetlights/CableImporter";

export default {
    name: 'Cables',
    components: {
        CableImporter,
        CableList,
        CableEditor, CableSearch},
    mixins: [restApi, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            results: [],
            cable: null,
            loading: false,
            lastSearchedParams: null,
            showFileImporter: false
        }
    },

    methods: {
        fetchCables: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.cableUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        editCable: function (cable) {
            this.cable = this.results.find((item => item.id === cable.id))
        },
        closeAndUpdate: function () {
            this.cable = null
            this.fetchCables(this.lastSearchedParams)
        },
        importFromFile() {
            this.showFileImporter = true
        },
        hideFileImporter() {
            this.showFileImporter = false
            this.fetchCables(this.lastSearchedParams)
        },
        exportExcel() {
            // TODO
        }
    }
}
</script>
